export const formatStepNumber = (stepNumber: number) =>
  stepNumber < 10 ? `0${stepNumber}` : stepNumber.toString();
